<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select v-model="formDatas.akwId" size="small" placeholder="请选择知识库" clearable @change="partserch"
                        style="width: 140px;">
                        <el-option v-for="item in getAiKnowledgeWareList_data || []" :label="item.akwName"
                            :value="item.akwId" :key="item.akwId">
                        </el-option>
                    </el-select>

                    <el-input v-model="formDatas.akfName" style="width: 140px;" size="small" placeholder="请输入文件名"
                        clearable></el-input>
                    <el-input v-model="formDatas.akfNameRelation" style="width: 140px;" size="small"
                        placeholder="请输入关联文件名" clearable></el-input>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="success" size="small" style="margin-left: 10px"
                        @click="isFileList = true">批量添加标签</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px"
                        @click="BoxOpen">新增知识库文件</el-button>

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="akfId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑知识库文件' : '新增知识库文件'"
                :before-close="handleClose" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer"
                ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="知识库名称" prop="akwId">
                                <el-select v-model="form.akwId" placeholder="请选择" clearable>
                                    <el-option v-for="item in getAiKnowledgeWareList_data || []" :label="item.akwName"
                                        :value="item.akwId" :key="item.akwId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="文件标签" prop="akflIds">
                                <el-cascader v-model="form.akflIds" :options="getAiKnowledgeFileLabelList_data || []"
                                    clearable collapse-tags filterable multiple :show-all-levels="false"
                                    :props="props"></el-cascader>
                            </el-form-item> -->

                            <el-form-item label="上传文件" prop="akfPath">
                                <my-uploadVideo ref="upload" @fileChange="FileChange" :filearr="fileList" :limit="1"
                                    style="margin: 10px 5px 5px;" @removeAfter="form.akfPath = ''" type="text">
                                </my-uploadVideo>
                            </el-form-item>
                            <el-form-item label="文件名称" prop="akfName">
                                <el-input v-model="form.akfName" style="width: 50%;" placeholder="请输入名称"></el-input>
                            </el-form-item>
                            <el-form-item label="行业标签" prop="akfLabelsIdsOne">
                                <el-select v-model="form.akfLabelsIdsOne" placeholder="请选择" clearable multiple>
                                    <el-option v-for="item in getAiKnowledgeFileLabelList1_data || []"
                                        :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="场景标签" prop="akfLabelsIdsTwo">
                                <el-select v-model="form.akfLabelsIdsTwo" placeholder="请选择" clearable multiple>
                                    <el-option v-for="item in getAiKnowledgeFileLabelList2_data || []"
                                        :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="核心业务产品标签" prop="akfLabelsIdsThree">
                                <el-select v-model="form.akfLabelsIdsThree" placeholder="请选择" clearable multiple>
                                    <el-option v-for="item in getAiKnowledgeFileLabelList3_data || []"
                                        :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="文件类型标签" prop="akfLabelsIdsFour">
                                <el-select v-model="form.akfLabelsIdsFour" placeholder="请选择" clearable multiple>
                                    <el-option v-for="item in getAiKnowledgeFileLabelList4_data || []"
                                        :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="目标客户标签" prop="akfLabelsIdsFive">
                                <el-select v-model="form.akfLabelsIdsFive" placeholder="请选择" clearable multiple>
                                    <el-option v-for="item in getAiKnowledgeFileLabelList5_data || []"
                                        :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="业务层级标签" prop="akfLabelsIdsSix">
                                <el-select v-model="form.akfLabelsIdsSix" placeholder="请选择" clearable multiple>
                                    <el-option v-for="item in getAiKnowledgeFileLabelList6_data || []"
                                        :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="核心痛点标签" prop="akfLabelsIdsSeven">
                                <el-select v-model="form.akfLabelsIdsSeven" placeholder="请选择" clearable multiple>
                                    <el-option v-for="item in getAiKnowledgeFileLabelList7_data || []"
                                        :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 批量导入打标签-->
            <el-dialog title="批量导入打标签" :visible.sync="isFileList" width="70%" top="8vh" :before-close="beforeBulkClose">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/ajtools/excel/aiKnowledgeFileLabels.xlsx', '批量打标签模板')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table ref="vetable2" v-if="tableDataFile" :columns="columnsFile" :table-data="tableDataFile"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" row-key-field-name="akfId" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
            </el-dialog>
            <!-- 修改文件标签-->
            <el-dialog title="修改文件标签" :visible.sync="isFlieAdd" width="70%" top="8vh">
                <el-form ref="formRef_file" :model="form" label-position="top" :rules="rules" style="height:100%">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="行业标签" prop="akfLabelsIdsOne">
                            <el-select v-model="form.akfLabelsIdsOne" placeholder="请选择" clearable multiple>
                                <el-option v-for="item in getAiKnowledgeFileLabelList1_data || []"
                                    :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="场景标签" prop="akfLabelsIdsTwo">
                            <el-select v-model="form.akfLabelsIdsTwo" placeholder="请选择" clearable multiple>
                                <el-option v-for="item in getAiKnowledgeFileLabelList2_data || []"
                                    :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="核心业务产品标签" prop="akfLabelsIdsThree">
                            <el-select v-model="form.akfLabelsIdsThree" placeholder="请选择" clearable multiple>
                                <el-option v-for="item in getAiKnowledgeFileLabelList3_data || []"
                                    :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="文件类型标签" prop="akfLabelsIdsFour">
                            <el-select v-model="form.akfLabelsIdsFour" placeholder="请选择" clearable multiple>
                                <el-option v-for="item in getAiKnowledgeFileLabelList4_data || []"
                                    :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="目标客户标签" prop="akfLabelsIdsFive">
                            <el-select v-model="form.akfLabelsIdsFive" placeholder="请选择" clearable multiple>
                                <el-option v-for="item in getAiKnowledgeFileLabelList5_data || []"
                                    :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="业务层级标签" prop="akfLabelsIdsSix">
                            <el-select v-model="form.akfLabelsIdsSix" placeholder="请选择" clearable multiple>
                                <el-option v-for="item in getAiKnowledgeFileLabelList6_data || []"
                                    :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="核心痛点标签" prop="akfLabelsIdsSeven">
                            <el-select v-model="form.akfLabelsIdsSeven" placeholder="请选择" clearable multiple>
                                <el-option v-for="item in getAiKnowledgeFileLabelList7_data || []"
                                    :label="item.akflName" :value="item.akflId" :key="item.akflId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose__file()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import {
    getAiKnowledgeWareList, getAiKnowledgeFileLabelList, getAiKnowledgeFileList,
    updateAiKnowledgeFile, addAiKnowledgeFile, deleteAiKnowledgeFile, uploadAiKnowledgeFileLabels

} from "../../api/api";
let Base64 = require("js-base64").Base64;
export default {
    name: "",
    components: {},
    data() {
        return {

            props: {
                multiple: true,
                checkStrictly: false,
                value: 'akflId',
                label: 'akflName',
                children: 'children',
            },
            getAiKnowledgeFileLabelList1_data: [],
            getAiKnowledgeFileLabelList2_data: [],
            getAiKnowledgeFileLabelList3_data: [],
            getAiKnowledgeFileLabelList4_data: [],
            getAiKnowledgeFileLabelList5_data: [],
            getAiKnowledgeFileLabelList6_data: [],
            getAiKnowledgeFileLabelList7_data: [],
            getAiKnowledgeWareList_data: [],
            isFlieAdd: false,
            formFile: {
                akfName: '',
                akfPath: ''
            },
            fileList: [],
            tableDataFile: [],
            isFileList: false,
            theItem: {},
            akcName_arr: [],
            OtherImgfileList: [],
            key: 'akfId',
            dialog: false,
            edit: false,
            form: {
                akfLabelsIdsOne: [],
                akfLabelsIdsTwo: [],
                akfLabelsIdsThree: [],
                akfLabelsIdsFour: [],
                akfLabelsIdsFive: [],
                akfLabelsIdsSix: [],
                akfLabelsIdsSeven: [],
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columnsFile: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",

                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "akfName",
                    key: "akfName",
                    title: "文件名称",
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.akfName}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesOne", key: "akfLabelsNamesOne", title: "行业标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;">
                                {
                                    row.akfLabelsNamesOne ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesOne).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesTwo", key: "akfLabelsNamesTwo", title: "场景标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;">
                                {
                                    row.akfLabelsNamesTwo ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesTwo).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesThree", key: "akfLabelsNamesThree", title: "核心业务产品标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;">
                                {
                                    row.akfLabelsNamesThree ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesThree).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesFour", key: "akfLabelsNamesFour", title: "文件类型标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;">
                                {
                                    row.akfLabelsNamesFour ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesFour).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesFive", key: "akfLabelsNamesFive", title: "目标客户标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;">
                                {
                                    row.akfLabelsNamesFive ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesFive).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesSix", key: "akfLabelsNamesSix", title: "业务层级标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;">
                                {
                                    row.akfLabelsNamesSix ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesSix).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesSeven", key: "akfLabelsNamesSeven", title: "核心痛点标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;">
                                {
                                    row.akfLabelsNamesSeven ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesSeven).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "status",
                    key: "status",
                    title: "状态",
                    align: "center",
                    edit: false,
                },
                {
                    field: "statusDes",
                    key: "statusDes",
                    title: "状态描述",
                    align: "center",
                    edit: false,
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },


            ], //表格的列
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                { field: "akfName", key: "akcName", fixed: "left", title: "文件名称", width: 250, align: "center" },
                {
                    field: "akwName",
                    key: "akwName",
                    title: "知识库名称",
                    align: "center",
                    edit: false,
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.akwName}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesOne", key: "akfLabelsNamesOne", title: "行业标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;" class="div_tag">
                                {
                                    row.akfLabelsNamesOne ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesOne).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesTwo", key: "akfLabelsNamesTwo", title: "场景标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;" class="div_tag">
                                {
                                    row.akfLabelsNamesTwo ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesTwo).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesThree", key: "akfLabelsNamesThree", title: "核心业务产品标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;" class="div_tag">
                                {
                                    row.akfLabelsNamesThree ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesThree).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesFour", key: "akfLabelsNamesFour", title: "文件类型标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;" class="div_tag">
                                {
                                    row.akfLabelsNamesFour ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesFour).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesFive", key: "akfLabelsNamesFive", title: "目标客户标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;" class="div_tag">
                                {
                                    row.akfLabelsNamesFive ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesFive).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesSix", key: "akfLabelsNamesSix", title: "业务层级标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;" class="div_tag">
                                {
                                    row.akfLabelsNamesSix ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesSix).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                {
                    field: "akfLabelsNamesSeven", key: "akfLabelsNamesSeven", title: "核心痛点标签", width: 250, align: "center", edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="width:100%;min-height:40px;" class="div_tag">
                                {
                                    row.akfLabelsNamesSeven ?
                                        <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}><el-tag >{JSON.parse(row.akfLabelsNamesSeven).join(',')}</el-tag></div>
                                        : <div style="width:100%;min-height:40px;" onDblclick={() => this.handleEdit_fileTagIds(row)}>
                                        </div>
                                }
                            </div>
                        )
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    fixed: "right",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.akfPath ? (
                                    <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() =>
                                            this.downloadFile(row.akfPath, row.akfName)
                                        }
                                    >
                                        下载
                                    </el-button>
                                ) : (
                                    ""
                                )}
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                akwName: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        getAiKnowledgeFileLabelList({ akflParentId: 1 }).then(res => {
            this.getAiKnowledgeFileLabelList1_data = res.data;
        })
        getAiKnowledgeFileLabelList({ akflParentId: 2 }).then(res => {
            this.getAiKnowledgeFileLabelList2_data = res.data;
        })
        getAiKnowledgeFileLabelList({ akflParentId: 3 }).then(res => {
            this.getAiKnowledgeFileLabelList3_data = res.data;
        })
        getAiKnowledgeFileLabelList({ akflParentId: 4 }).then(res => {
            this.getAiKnowledgeFileLabelList4_data = res.data;
        })
        getAiKnowledgeFileLabelList({ akflParentId: 5 }).then(res => {
            this.getAiKnowledgeFileLabelList5_data = res.data;
        })
        getAiKnowledgeFileLabelList({ akflParentId: 6 }).then(res => {
            this.getAiKnowledgeFileLabelList6_data = res.data;
        })
        getAiKnowledgeFileLabelList({ akflParentId: 7 }).then(res => {
            this.getAiKnowledgeFileLabelList7_data = res.data;
        })
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAiKnowledgeWareList().then(res => {
            this.getAiKnowledgeWareList_data = res.data;
        })

        this.getList();
    },
    mounted() { },
    methods: {
        beforeBulkClose() {
            this.isFileList = false;
            this.partserch()
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAiKnowledgeFileLabels(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.tableDataFile = res.data;
            })
        },
        handleEdit_fileTagIds(row) {
            console.log(row);

            const data = JSON.parse(JSON.stringify(row))
            this.isFlieAdd = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.akfPath = data.akfPath;
                this.form.akfLabelsIdsOne = data.akfLabelsIdsOne ? JSON.parse(data.akfLabelsIdsOne) : [];
                this.form.akfLabelsIdsTwo = data.akfLabelsIdsTwo ? JSON.parse(data.akfLabelsIdsTwo) : [];
                this.form.akfLabelsIdsThree = data.akfLabelsIdsThree ? JSON.parse(data.akfLabelsIdsThree) : [];
                this.form.akfLabelsIdsFour = data.akfLabelsIdsFour ? JSON.parse(data.akfLabelsIdsFour) : [];
                this.form.akfLabelsIdsFive = data.akfLabelsIdsFive ? JSON.parse(data.akfLabelsIdsFive) : [];
                this.form.akfLabelsIdsSix = data.akfLabelsIdsSix ? JSON.parse(data.akfLabelsIdsSix) : [];
                this.form.akfLabelsIdsSeven = data.akfLabelsIdsSeven ? JSON.parse(data.akfLabelsIdsSeven) : [];
                if (data.akfPath && data.akfPath.split(',').length > 0) {
                    data.akfPath.split(',').forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img);
                    })

                }
            })
        },
        downloadFile(url, name) {
            //下载
            if (!url) {
                return;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        },
        handleDelete2(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAiKnowledgeFile({ akfId: row.akfId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit2(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.isFlieAdd = true;
            this.edit = true;
            this.$nextTick(() => {
                this.formFile = data;
                this.formFile.akfPath = data.akfPath.split(',')
                if (this.form.akfPath && this.form.akfPath.length > 0) {
                    this.form.akfPath.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img);
                    })

                }
            })
        },
        SureBtn2() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const data = JSON.parse(JSON.stringify(this.formFile))
                        data.akfId = this.theItem.akfId
                        addAiKnowledgeFile(data).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose2()
                                this.getList2()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const data = JSON.parse(JSON.stringify(this.formFile))
                        data.akfId = this.theItem.akfId
                        updateAiKnowledgeFile(data).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose2()
                                this.getList2()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        addFile() {
            this.isFlieAdd = true;
            this.$nextTick(() => {
                this.formFile.akfPath = ''
                this.fileList = []
            })
        },
        FileChange(file) {
            console.log(file);
            if (file.length > 0) {
                this.$set(this.form, 'akfPath', file[0].fileurl)
                this.$set(this.form, 'akfName', file[0].fileName)
                this.$message({
                    type: "success",
                    message: "上传成功!",
                });
            } else {
                this.$message({
                    type: "error",
                    message: "上传失败!",
                });
            }

        },
        handleClose2() {
            this.isFlieAdd = false;
            this.$refs['formRef'].resetFields();
            this.fileList = []
            this.edit = false;
        },

        openFileList(row) {
            getAiKnowledgeFileList({ akfId: row.akfId }).then(res => {
                this.tableDataFile = res.data
                this.theItem = row;
                this.isFileList = true;
            })

        },
        OtherImgChange(file) {
            console.log(file);
            this.$set(this.form, 'aaIcon', file[0].url)
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAiKnowledgeFile({ akfIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAiKnowledgeFile({ akfId: row.akfId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.akfPath = data.akfPath;
                this.form.akfLabelsIdsOne = data.akfLabelsIdsOne ? JSON.parse(data.akfLabelsIdsOne) : [];
                this.form.akfLabelsIdsTwo = data.akfLabelsIdsTwo ? JSON.parse(data.akfLabelsIdsTwo) : [];
                this.form.akfLabelsIdsThree = data.akfLabelsIdsThree ? JSON.parse(data.akfLabelsIdsThree) : [];
                this.form.akfLabelsIdsFour = data.akfLabelsIdsFour ? JSON.parse(data.akfLabelsIdsFour) : [];
                this.form.akfLabelsIdsFive = data.akfLabelsIdsFive ? JSON.parse(data.akfLabelsIdsFive) : [];
                this.form.akfLabelsIdsSix = data.akfLabelsIdsSix ? JSON.parse(data.akfLabelsIdsSix) : [];
                this.form.akfLabelsIdsSeven = data.akfLabelsIdsSeven ? JSON.parse(data.akfLabelsIdsSeven) : [];
                console.log(this.form.akflIds);
                if (data.akfPath && data.akfPath.split(',').length > 0) {
                    data.akfPath.split(',').forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img);
                    })

                }
            })
        },
        SureBtn() {
            console.log(this.form.akflIds);
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const data = JSON.parse(JSON.stringify(this.form));
                        data.akfLabelsIdsOne = data.akfLabelsIdsOne ? JSON.stringify(data.akfLabelsIdsOne) : '';
                        data.akfLabelsIdsTwo = data.akfLabelsIdsTwo ? JSON.stringify(data.akfLabelsIdsTwo) : '';
                        data.akfLabelsIdsThree = data.akfLabelsIdsThree ? JSON.stringify(data.akfLabelsIdsThree) : '';
                        data.akfLabelsIdsFour = data.akfLabelsIdsFour ? JSON.stringify(data.akfLabelsIdsFour) : '';
                        data.akfLabelsIdsFive = data.akfLabelsIdsFive ? JSON.stringify(data.akfLabelsIdsFive) : '';
                        data.akfLabelsIdsSix = data.akfLabelsIdsSix ? JSON.stringify(data.akfLabelsIdsSix) : '';
                        data.akfLabelsIdsSeven = data.akfLabelsIdsSeven ? JSON.stringify(data.akfLabelsIdsSeven) : '';
                        addAiKnowledgeFile(data).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const data = JSON.parse(JSON.stringify(this.form))
                        data.akfLabelsIdsOne = data.akfLabelsIdsOne ? JSON.stringify(data.akfLabelsIdsOne) : '';
                        data.akfLabelsIdsTwo = data.akfLabelsIdsTwo ? JSON.stringify(data.akfLabelsIdsTwo) : '';
                        data.akfLabelsIdsThree = data.akfLabelsIdsThree ? JSON.stringify(data.akfLabelsIdsThree) : '';
                        data.akfLabelsIdsFour = data.akfLabelsIdsFour ? JSON.stringify(data.akfLabelsIdsFour) : '';
                        data.akfLabelsIdsFive = data.akfLabelsIdsFive ? JSON.stringify(data.akfLabelsIdsFive) : '';
                        data.akfLabelsIdsSix = data.akfLabelsIdsSix ? JSON.stringify(data.akfLabelsIdsSix) : '';
                        data.akfLabelsIdsSeven = data.akfLabelsIdsSeven ? JSON.stringify(data.akfLabelsIdsSeven) : '';
                        updateAiKnowledgeFile(data).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.isFlieAdd = false ? this.handleClose() : this.handleClose__file();
                                // this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        handleClose__file() {
            this.edit = false;
            this.isFlieAdd = false;
            if (this.$refs['formRef_file']) {
                this.$refs['formRef_file'].resetFields();
            }
            if (this.$refs['formRef']) {
                this.$refs['formRef'].resetFields();
            }
            this.fileList = [];
            this.form = {
                akfLabelsIdsOne: [],
                akfLabelsIdsTwo: [],
                akfLabelsIdsThree: [],
                akfLabelsIdsFour: [],
                akfLabelsIdsFive: [],
                akfLabelsIdsSix: [],
                akfLabelsIdsSeven: [],
            }
        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.isFlieAdd = false;
            this.$refs['formRef'].resetFields();
            this.fileList = [];
            this.form = {
                akfLabelsIdsOne: [],
                akfLabelsIdsTwo: [],
                akfLabelsIdsThree: [],
                akfLabelsIdsFour: [],
                akfLabelsIdsFive: [],
                akfLabelsIdsSix: [],
                akfLabelsIdsSeven: [],
            }
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.akfId = row.akfId
                    console.log(jsonObj);
                    updateAiKnowledgeFile(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAiKnowledgeFileList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAiKnowledgeFileList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAiKnowledgeFileList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.div_tag /deep/ .el-tag {
    height: auto !important;
    min-height: 32px !important;
    white-space: initial !important
}

.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>